import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BookingsRoutingModule } from './bookings-routing.module';
import { BookingsComponent } from './bookings/bookings.component';
import { BookingsListComponent } from './bookings-list/bookings-list.component';
import { BookingsModifyComponent } from './bookings-modify/bookings-modify.component';
import { BookingTransactionHistoryComponent } from '../bookings/booking-transaction-history/booking-transaction-history.component';
import { SharedModule } from '../../../../shared/shared.module';
import { HcaBookingService } from '../../../../shared/_services/hca-booking.service';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    BookingsRoutingModule
  ],
  declarations: [BookingsComponent, BookingsListComponent, BookingsModifyComponent, BookingTransactionHistoryComponent],
  providers: [HcaBookingService]
})
export class BookingsModule { }



// WEBPACK FOOTER //
// ./src/app/components/admin/hca-admin/bookings/bookings.module.ts